export const DEFAULT_EDGE_SIZE = {
  width: 202,
  height: 36
};
